class ContractualSplitShiftStrategy {
     calculateAttendance(employee, attendanceData) {
          console.log('👷 Contractual Split Shift Strategy - Calculating attendance for:', employee.employee_name);

          const {
               shift_description_1,
               shift_description_2,
               in_time_1,
               out_time_1,
               in_time_2,
               out_time_2,
               total_hours,
               WorkingsHoursToBeConsiderdFullDay,
               WorkingsHoursToBeConsiderdHalfDay
          } = attendanceData;

          // Validate both shifts are present
          if (!shift_description_1 || !shift_description_2) {
               console.warn('⚠️ Split shift configuration incomplete');
               return { status: 'A', remarks: 'Split shift not configured' };
          }

          // Check if both shifts have attendance
          const hasFirstShift = in_time_1 && out_time_1;
          const hasSecondShift = in_time_2 && out_time_2;

          if (!hasFirstShift && !hasSecondShift) {
               return { status: 'A', remarks: 'Absent - No attendance in both shifts' };
          }

          // Parse total hours
          const hoursWorked = parseFloat(total_hours) || 0;
          const fullDayHours = parseFloat(WorkingsHoursToBeConsiderdFullDay) || 8;
          const halfDayHours = parseFloat(WorkingsHoursToBeConsiderdHalfDay) || 4;

          // Determine attendance status
          if (hoursWorked >= fullDayHours) {
               return {
                    status: 'P',
                    remarks: `Present - Split Shift (${shift_description_1}, ${shift_description_2})`
               };
          } else if (hoursWorked >= halfDayHours) {
               return {
                    status: 'HD',
                    remarks: `Half Day - Split Shift (${hoursWorked.toFixed(2)} hours)`
               };
          } else if (hoursWorked > 0) {
               return {
                    status: 'HD',
                    remarks: `Half Day - Incomplete split shift (${hoursWorked.toFixed(2)} hours)`
               };
          } else {
               return { status: 'A', remarks: 'Absent - No valid working hours' };
          }
     }
}

export default ContractualSplitShiftStrategy;